/** Repositorio único de la aplicación (IndexedDB en la v1). */

import { ulid } from 'ulid';
import { RepositorioIndexedDB } from '../../persistencia/repositorio';

let unico: RepositorioIndexedDB | null = null;

export function repositorio(): RepositorioIndexedDB {
  unico ??= new RepositorioIndexedDB();
  return unico;
}

export const nuevoId = (): string => ulid();
